import type { FunctionComponent } from "react"

import { TeamsJobPositions } from "@/features/companyDetail/components/Teams/TeamsJobPositions/TeamsJobPositions"
import { TeamsPresentation } from "@/features/companyDetail/components/Teams/TeamsPresentation/TeamsPresentation"
import { TeamsTitle } from "@/features/companyDetail/components/Teams/TeamsTitle/TeamsTitle"

export const TeamsWrapper: FunctionComponent = () => (
  <>
    <TeamsTitle />
    <TeamsPresentation />
    <TeamsJobPositions />
  </>
)
